import { motion } from "framer-motion";
import { STATS } from "../data";

export const Stats = () => {
  return (
    <section className="relative mx-auto max-w-7xl px-5 py-16 md:px-10">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="rounded-2xl border border-white/10 bg-[#0B111E] p-6 text-center backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#3B82F6]/40"
          >
            <div className="font-heading text-3xl font-extrabold text-white md:text-4xl">
              <span className="gradient-text">{s.value}</span>
            </div>
            <div className="mt-2 text-xs font-semibold uppercase tracking-wider text-gray-400 md:text-sm">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
